import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';

export const postLogoutEndpoint = "post-logout";

export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.oidc.authority,
  redirectUri: `${standardizeURL(environment.baseURL)}`,
  clientId: environment.oidc.clientId,
  responseType: 'code',
  scope: 'altinn:instances.read altinn:instances.write altinn:reportees',
  showDebugInformation: true,
  preserveRequestedRoute: true,
  //silentRefreshRedirectUri: `${environment.baseURL}silent-refresh.html`,
  strictDiscoveryDocumentValidation: false,
  postLogoutRedirectUri: `${standardizeURL(environment.baseURL)}/${postLogoutEndpoint}`,
  customQueryParams: {
    acr_values: 'idporten-loa-substantial',
    ui_locales: 'nb'
  },
};

// Guards against typos in the hand-edited baseURL of each environment: callers append their own
// path separator, so a trailing slash has to come off, and ID-porten only accepts https redirect
// URIs.
export function standardizeURL(url: string) {
  let result = url;

  if (result.endsWith('/')) {
    result = result.slice(0, -1);
  }

  if (result.startsWith('http://')) {
    result = result.replace('http://', 'https://');
  }

  return result;
}

